// extracted by mini-css-extract-plugin
export default {"app":"DLE0pN","scrollable":"PfMd4C","baseStyles":"CeMJla","mobileBaseStyles":"vZTjwN"};